import React from "react"
import { theme } from "../settings/config"
import Input from "../atomize/input/Input"

function DateInput({ handleChange, value, shadow, m, h, ...others }) {
	return (
		<Input
			type="date"
			shadow={shadow}
			rounded={"20px"}
			value={value}
			bg="surface"
			border="3px solid"
			borderColor={theme.colors.surface}
			focusBorderColor={theme.colors.gunmetal}
			textColor={theme.colors.text}
			textAlign="left"
			p={{ x: "1rem" }}
			m={{ b: m || "0.5rem" }}
			h={h ?? "3.5rem"}
			w="100% !important"
			style={{ WebkitAppearance: "none" }}
			onChange={e => {
				handleChange(e.target.value)
			}}
			{...others}
		/>
	)
}

export default DateInput
